import { Button } from '@/shared/components/shadcn/button';

import {
  canCancelRun,
  canExportRun,
  useScrapingRunActions,
} from '../../model/use-scraping-run-actions';
import { type ScrapingRunSummary } from '../../types';

type ScrapingRunActionsProps = {
  run: ScrapingRunSummary;
  intent_id: string;
};

export function ScrapingRunActions({ run, intent_id }: ScrapingRunActionsProps) {
  const { cancelMutation, exportMutation } = useScrapingRunActions(intent_id);
  const cancelable = canCancelRun(run);
  const exportable = canExportRun(run);

  return (
    <div className="flex flex-wrap items-center justify-end gap-2">
      <Button
        variant="outline"
        size="sm"
        disabled={!exportable}
        loading={exportMutation.isPending && exportMutation.variables?.run_id === run.run_id}
        onClick={() => exportMutation.mutate(run)}
      >
        Export
      </Button>
      <Button
        variant="outline"
        size="sm"
        disabled={!cancelable}
        loading={cancelMutation.isPending && cancelMutation.variables === run.run_id}
        onClick={() => cancelMutation.mutate(run.run_id)}
      >
        Cancel
      </Button>
    </div>
  );
}
